import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import { createModel } from '@kp/js-model';

export class ZuordnungImportHeader extends BaseModel {
    // properties
    id: number | null = null;
    header: string | null = null;
    headergroup: string | null = null;
    target_tabelle: string | null = null;
    source_temp_tabelle: string | null = null;
    feld: string | null = null;
    anzeige_name: string | null = null;
    jahr: number | null = null;
    kanton_id: number | null = null;

    getClassName(): string {
        return 'ZuordnungImportHeader';
    }
}

export async function createNewZuordnungImportHeader(): Promise<ZuordnungImportHeader> {
    const model = createModel(ZuordnungImportHeader, {});

    await model.save();
    return model;
}

export class ZuordnungImportHeaderCollection extends BaseCollection<ZuordnungImportHeader> {
    protected modelCls = ZuordnungImportHeader;

    public getModelClassName(): string {
        return 'ZuordnungImportHeader';
    }
}
